export default __webpack_public_path__ + "static/sprite-271e324dc140782a1a2587f35a4864c0.svg";